import { Platform } from 'react-native';

/**
 * Returns `true` for the web platform, since we use redirect flow there.
 */
export function checkIfShouldHandleRedirectResponse() {
  return Platform.OS === 'web';
}
